import React from 'react';
import { connect } from 'react-redux';
import { Icon, List } from 'antd';
import Client from '../Form/Form';
import Preloader from '../../Preloader/Preloader';
import UpdateClientWrapper from './UpdateClient.style';
import { getIcBoxUserList, setIcBoxUserSearch, setIcBoxUserSearchText, setIcBoxUserToUpdate, getClient } from '../../../redux/actions/Client/ClientActions';

class UpdateClient extends React.Component {
  
  constructor() {
    super();
    this.handleClientSearch = this.handleClientSearch.bind(this);
    this.handleUpdateClient = this.handleUpdateClient.bind(this);
  }

  componentDidMount() {
    this.props.getIcBoxUserList();
    this.props.setIcBoxUserSearch([]);
    this.props.setIcBoxUserSearchText('');
    this.props.setIcBoxUserToUpdate({});
  }

  handleClientSearch(e) {
    const search_keyword = e.target.value.toLowerCase();
    let filtered_users = this.props.CLIENTSREDUCER.ic_box_user.list.filter(user => user.name.toLowerCase().includes(search_keyword));
    this.props.setIcBoxUserSearchText(search_keyword); 
    this.props.setIcBoxUserSearch(filtered_users);
  }

  handleUpdateClient(username) {
    this.props.getClient(username);
  }
  
  render() {

    let ic_box_user_list = this.props.CLIENTSREDUCER.ic_box_user.list;
    let search_results = this.props.CLIENTSREDUCER.ic_box_user.search_results;
    let search_text = this.props.CLIENTSREDUCER.ic_box_user.search_text;

    let data_source = search_text.length > 0 || search_results.length > 0 ? search_results : ic_box_user_list;

    if(Object.keys(this.props.CLIENTSREDUCER.ic_box_user.user_to_update).length > 0) {
      return (
        <Client from="update" />
      )
    }
    else {
      if(this.props.APPREDUCER.showPreloader === true) {
        return(
          <Preloader />
        )
      }
      else {
        return(
          <UpdateClientWrapper>
              <input type="text" placeholder="Search for clients by name here..." className="search-client-input" onChange={(e) => this.handleClientSearch(e)} />
              <List
                header={<div className="flex header-user-wrapper">
                          <p className="user-name">Name</p>
                          <p className="user-email">Email ID</p>
                          <p className="user-username">User Name</p>
                        </div>}
                dataSource={data_source}
                renderItem={(user,i) => (<List.Item key={i+1}>
                  <div className="flex user-wrapper">
                    <p className="user-name">{user.name}</p>
                    <p className="user-email">{user.email}</p>
                    <p className="user-username">{user.username}</p>
                    <div className="user-actions">
                      <Icon className="user-update-icon" type="edit" onClick={() => this.handleUpdateClient(user.username)} />
                    </div>
                  </div>
                  </List.Item>)}
                pagination={true}
              />
          </UpdateClientWrapper>
        )
      }
    }
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  getIcBoxUserList,
  setIcBoxUserSearch,
  setIcBoxUserSearchText,
  setIcBoxUserToUpdate,
  getClient
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateClient);


// WEBPACK FOOTER //
// ./src/components/Client/UpdateClient/UpdateClient.js